<template>
  <v-dialog v-model="value.show" max-width="600">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="10">
            {{ value.title }}
          </v-col>

          <v-col class="text-right">
            <v-btn depressed icon @click="value.show = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <template v-if="value.content">
          {{ value.content }}
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MessageDialog',
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return {
          show: false,
        };
      },
    },
  },
};
</script>
